import { Form } from 'factorial-form'
import _ from 'lodash'
import moment from 'moment'

import type PublicHoliday from 'modules/locations/store/models/PublicHoliday'

function isEqualOrEmpty(
  field: string | null | undefined,
  model: PublicHoliday,
  key: string
): boolean {
  const value = model.attributes[key] || ''

  return value.toLowerCase() === field || _.isEmpty(value)
}

// FIXME: Why is this function exact same as isEqualOrEmpty?
function isEqual(field: string | null | undefined, model: PublicHoliday, key: string): boolean {
  const value = model.attributes[key] || ''

  return value.toLowerCase() === field || _.isEmpty(value)
}

class ImportPublicHolidays extends Form {
  constructor(values: {}) {
    super(values, {
      country: 'string',
      region: 'string',
      city: 'string',
      year: 'number',
    })
  }

  formValues() {
    return Object.fromEntries(
      Object.entries(this.values).map(([key, value]) => {
        return [key, value?.toLowerCase()]
      })
    )
  }

  matchingHolidays(holidays: PublicHoliday[]): PublicHoliday[] {
    const { year, country, region, city } = this.formValues()

    return holidays.filter((holiday) => {
      return (
        +year === moment(holiday.get('date')).year() &&
        isEqual(country, holiday, 'country') &&
        isEqualOrEmpty(region, holiday, 'region') &&
        isEqualOrEmpty(city, holiday, 'city')
      )
    })
  }

  matchingHolidaysNotEmpty(holidays: PublicHoliday[]): PublicHoliday[] {
    const { year, country, region } = this.formValues()

    return holidays.filter((holiday) => {
      return (
        +year === moment(holiday.get('date')).year() &&
        isEqual(country, holiday, 'country') &&
        isEqual(region, holiday, 'region')
      )
    })
  }
}

export default ImportPublicHolidays
